import { CardModel } from "../../interface/game";
import { SequencePolicy } from "./sequence-policy";
import { CardValueSequence } from "./sequence-values";

export function sequenceSingleSuitPolicy(desc: boolean = true): SequencePolicy {
    return (prev: CardModel, next: CardModel): boolean => {
        const [po, no] = desc ? [0, 1] : [1, 0];
        return prev.suit === next.suit 
            && CardValueSequence[prev.value] + po === CardValueSequence[next.value] + no;
    }
}